// src/layouts/DashboardLayout.jsx
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const Container = styled.div`
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const Sidebar = styled.nav`
  flex: 0 0 220px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border: 1px solid #e8ecef;

  a {
    display: block;
    margin-bottom: 12px;
    color: #333;
    text-decoration: none;
    font-weight: 500;

    &.active {
      color: #1B6392;
    }
    &:hover {
      color: #1B6392;
    }
  }
`;

export default function DashboardLayout() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        const token = sessionStorage.getItem("accessToken");
        if (!token) {
            return navigate("/user-account/sign-in", { replace: true });
        }
    }, [navigate]);

    return (
        <Container>
            <Inner>
                <Sidebar>
                    <Link to="/profile"       className={pathname === "/profile" ? "active" : ""}>Личный кабинет</Link>
                    <Link to="/profile/orders" className={pathname === "/profile/orders" ? "active" : ""}>История заказов</Link>
                    <Link to="/shopping-cart"    className={pathname === "/profile/cart" ? "active" : ""}>Корзина покупок</Link>
                    <Link to="/profile/settings" className={pathname === "/profile/settings" ? "active" : ""}>Настройки</Link>
                    <Link to="/logout">Выход</Link>
                </Sidebar>

                {/* Outlet отрисует либо ProfilePage, либо OrderHistoryPage и т.д. */}
                <div style={{ flex: 1 }}>
                    <Outlet/>
                </div>
            </Inner>
        </Container>
    );
}
